import { createContext, useContext, useState } from "react"

export const ScrollContext = createContext()

import React from "react"

export const ScrollProvider = ({ children }) => {
  const [position, setPosition] = useState(0)
  return (
    <ScrollContext.Provider value={{ position, setPosition }}>
      {children}
    </ScrollContext.Provider>
  )
}

export const useScrollContext = () => {
  const context = useContext(ScrollContext)
  if (!context) {
    throw new Error("useScrollContext must be used within ScrollProvider")
  }
  return context
}
